var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: "#137752",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.29,28.56c-.36,0-.72-.13-1-.36L2,19.63c-.66-.55-.75-1.53-.2-2.2.55-.66,1.53-.75,2.2-.2l8.86,7.38L25.65,2.23c.43-.75,1.38-1.01,2.13-.58.75.43,1.01,1.38.58,2.13l-13.71,24c-.23.4-.62.68-1.08.76-.09.02-.18.02-.28.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.0ee6cea947c3036f6ba0308c24c4d2f3.svg";
export { ForwardRef as ReactComponent };